/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual interest rate (%)`)
};

const es_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa de interés anual (%)`)
};

const de_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlicher Zinssatz (%)`)
};

const nl_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse rente (%)`)
};

const fr_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux d'intérêt annuel (%)`)
};

const it_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasso di interesse annuale (%)`)
};

const pt_br2_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de juros anual (%)`)
};

const pt_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de juro anual (%)`)
};

const ja_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「年利率 (%)」`)
};

const zh_ln_rate_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年利率（%）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_rate_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_rate_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_rate_label", locale)
	if (locale === "en") return en_ln_rate_label(inputs)
	if (locale === "es") return es_ln_rate_label(inputs)
	if (locale === "de") return de_ln_rate_label(inputs)
	if (locale === "nl") return nl_ln_rate_label(inputs)
	if (locale === "fr") return fr_ln_rate_label(inputs)
	if (locale === "it") return it_ln_rate_label(inputs)
	if (locale === "pt-BR") return pt_br2_ln_rate_label(inputs)
	if (locale === "pt") return pt_ln_rate_label(inputs)
	if (locale === "ja") return ja_ln_rate_label(inputs)
	return zh_ln_rate_label(inputs)
};